<template>
    <div class=slideshow>

        <div class=swiper-container>

            <div class=swiper-wrapper>

                <div
                    class=swiper-slide
                    v-for="(slide, i) in slides"
                    :key="i"
                    @click="showPopup"
                >
                    <div>
                        <InlineVideo v-if="slide.video" :ref="'slideVideo' + i" :video="slide.video" :image="slide.image" />

                        <img :src="slide.image">

                        <div class=slide-title :class="{ 'hide-on-mobile' : ( slide.title.length > 200 ) }"><h3>{{ slide.title }}</h3></div>
                    </div>

                </div>

            </div>

            <div v-show="hasNav" class=swiper-navigation>

                <div class="swiper-button-prev" ></div>
                <div class="swiper-button-next" ></div>

            </div>

        </div>

        <SlideshowPopup
            v-if="hasPopup"
            :media="popupMedia"
            :active="popupActive"
            :hasNav="slides.length > 1"
            :wp="wp"
            @close-popup="closePopup"
            @slide-prev="slidePrev"
            @slide-next="slideNext"
        />

    </div>
</template>
<script>
import Swiper, { Navigation, Lazy } from 'swiper';
import 'swiper/swiper-bundle.min.css';

Swiper.use( [ Navigation, Lazy ] )

import SlideshowPopup from './SlideshowPopup.vue';
import InlineVideo    from './InlineVideo.vue';

export default {
    name : 'Slideshow',
    props : {
        slides               : Array    ,
        settings             : Object   ,
        selector             : String   ,
        hasPopup             : Boolean  ,
        wp                   : Boolean  ,
    },
    components : {
        SlideshowPopup,
        InlineVideo,
    },
    data() {
        return {
            inited      : false,
            slideshow   : null ,
            popupImage  : null ,
            popupText   : null ,
            popupActive : false,
            hasNav      : true ,
        }
    },
    methods : {
        init() {
            if( this.slides ) {

                let defaultOptions = {
                    slidesPerView   : 'auto' ,
                    loop            : false  ,
                    speed           : 200    ,
                    centeredSlides  : true   ,
                    spaceBetween    : 192    ,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    on : {
                        slideChange : this.slideChange,
                    },
                    breakpoints : {
                        1024 : {
                            spaceBetween : 140,
                        },
                        1600 : {
                            spaceBetween : 192,
                        }
                    }
                }

                let options = null;

                if( this.settings ) {
                    options = Object.assign( defaultOptions, this.settings );
                }
                else {
                    options = defaultOptions;
                }

                this.slideshow = new Swiper( this.elemSelector + ' .swiper-container', options);

                this.hasNav = !!options.navigation;

                this.inited = true;
            }

        },
        showPopup() {
            this.popupImage  = this.slides[this.activeSlide].image;
            this.popupText   = this.slides[this.activeSlide].title;
            this.popupActive = true;
        },
        closePopup() {
            this.popupActive = false;
        },
        slideTo( index ) {
            this.slideshow.slideTo( index );
        },
        slideNext() {
            this.slideshow.slideNext();
        },
        slidePrev() {
            this.slideshow.slidePrev();
        },
        slideChange() {
            if( this.slideshow ) {
                this.$emit('slide-change', this.slideshow.realIndex );

                if( this.activeSlideHasVideo ) {
                    this.playVideo();
                }
            }
        },
        playVideo() {
            this.$refs['slideVideo' + this.activeSlide ][0].play();
        },
    },
    computed : {
        elemSelector() {
            return this.selector || '.slideshow';
        },
        activeSlide() {
            return this.slideshow ? this.slideshow.realIndex : 0;
        },
        popupMedia() {
            return {
                video : this.slides[this.activeSlide].video || '',
                image : this.slides[this.activeSlide].image || '',
                title : this.slides[this.activeSlide].title || '',
            };
        },
        activeSlideHasVideo() {
            return !!this.slides[this.activeSlide].video;
        }
    },
    mounted() {
        if( !this.inited ) {
            this.init();
        }
    },
    watch : {
        slides() {
            if( !this.inited ) {
                this.init();
            }
        },
    }
}
</script>